/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseClinicDoctorDto } from '../../models/response-clinic-doctor-dto';

export interface ClinicDoctorControllerFindOne$Params {

/**
 * The tenant ID (hash key)
 */
  tenant: string;

/**
 * The composite range key (clinic ID and doctor ID)
 */
  clinicId: string;

/**
 * The composite range key (clinic ID and doctor ID)
 */
  doctorId: string;
}

export function clinicDoctorControllerFindOne(http: HttpClient, rootUrl: string, params: ClinicDoctorControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseClinicDoctorDto>> {
  const rb = new RequestBuilder(rootUrl, clinicDoctorControllerFindOne.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('clinicId', params.clinicId, {});
    rb.path('doctorId', params.doctorId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseClinicDoctorDto>;
    })
  );
}

clinicDoctorControllerFindOne.PATH = '/thalea-clinics/clinic-doctors/{tenant}/{clinicId}/{doctorId}';
